import React, { useState } from 'react';
import './PrimeFactorization.css';  // We'll create this file next

const PrimeFactorization = () => {
  const [number, setNumber] = useState('');
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  const decomposeIntoPrimeFactors = (n) => {
    const factors = [];
    let divisor = 2;
    let num = n;

    while (num > 1) {
      let count = 0;
      while (num % divisor === 0) {
        num = Math.floor(num / divisor);
        count++;
      }
      if (count > 0) {
        factors.push([divisor, count]);
      }
      divisor++;
      if (divisor * divisor > num) {
        if (num > 1) {
          factors.push([num, 1]);
        }
        break;
      }
    }
    return factors;
  };

  const handleFactorize = (e) => {
    e?.preventDefault();
    setError('');
    setResult('');

    try {
      const inputNumber = parseInt(number);
      if (isNaN(inputNumber) || inputNumber <= 1) {
        setError('Please enter a number greater than 1');
        return;
      }

      const factors = decomposeIntoPrimeFactors(inputNumber);
      const resultString = factors
        .map(([base, exponent]) => `${base}^${exponent}`)
        .join(' * ');
      
      setResult(resultString);
    } catch (err) {
      setError('Invalid input. Please enter a valid integer.');
    }
  };

  return (
    <div className="container">
      <h1 className="title">Prime Factorization Tool</h1>

      <form onSubmit={handleFactorize} className="form">
        <div className="input-group">
          <label className="label">Enter a number:</label>
          <input
            type="number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="Enter a positive integer"
            className="input"
          />
        </div>

        <button type="submit" className="button">
          Factorize
        </button>

        {error && (
          <div className="error">
            {error}
          </div>
        )}

        {result && (
          <div className="result">
            <span className="result-label">Prime Factorization: </span>
            <span className="result-value">{result}</span>
          </div>
        )}
      </form>
    </div>
  );
};

export default PrimeFactorization;
